var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_401_25726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3C10 3 10 2.60218 9.84776 2.23463C9.64477 1.74458 9.25542 1.35523 8.76537 1.15224C8.39782 1 7.93188 1 7 1C6.06812 1 5.60217 1 5.23463 1.15224C4.74458 1.35523 4.35523 1.74458 4.15224 2.23463C4 2.60218 4 3.06812 4 4L4 7M4.2 15H9.8C10.9201 15 11.4802 15 11.908 14.782C12.2843 14.5903 12.5903 14.2843 12.782 13.908C13 13.4802 13 12.9201 13 11.8V10.2C13 9.07989 13 8.51984 12.782 8.09202C12.5903 7.71569 12.2843 7.40973 11.908 7.21799C11.4802 7 10.9201 7 9.8 7H4.2C3.0799 7 2.51984 7 2.09202 7.21799C1.71569 7.40973 1.40973 7.71569 1.21799 8.09202C1 8.51984 1 9.07989 1 10.2V11.8C1 12.9201 1 13.4802 1.21799 13.908C1.40973 14.2843 1.71569 14.5903 2.09202 14.782C2.51984 15 3.07989 15 4.2 15Z",
    stroke: "#B0B9C7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 6.5,
    r: 5.90909,
    fill: "#C30A0A",
    stroke: "white",
    strokeWidth: 1.18182
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_401_25726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.717 8.716L10.5011 6.50009M10.5011 6.50009L8.28516 4.28418M10.5011 6.50009L12.717 4.28418M10.5011 6.50009L8.28516 8.716",
    stroke: "white",
    strokeWidth: 1.18182,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_401_25726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_401_25726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.90909,
    height: 5.90909,
    fill: "white",
    transform: "translate(7.54688 3.54541)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockError);
export default __webpack_public_path__ + "static/media/LockError.2c28aec61955c934ca16492fc0754468.svg";
export { ForwardRef as ReactComponent };